import { generate, itemLink } from '../shared.config';
import pluralize from 'pluralize';
import _ from 'lodash-es';
import { strapiImage } from '$lib/utils';
import type ListConfigI from '$interfaces/misc/list-config.interface';

export const filterPagesRaw = (name: string) => [
  {
    name: `Cheapest ${pluralize(name)}`,
    icon: 'magnifying-glass-dollar',
    slug: 'cheapest',
    params: {
      sort: ['minPrice:asc'],
      filters: { $and: [{ minPrice: { $notNull: true } }] },
    },
  },
  {
    name: `Most Expensive ${pluralize(name)}`,
    icon: 'sack-dollar',
    slug: 'most-expensive',
    params: {
      sort: ['maxPrice:desc'],
      filters: { $and: [{ minPrice: { $notNull: true } }] },
    },
  },
];

const filterPages = filterPagesRaw('Gloves');

export const jumboButtons = (data) => {
  const baseUrl = '/skins/gloves/';

  const buttons: any = [
    {
      text: 'Glove Types',
      properties: {
        dropdown: true,
        options: data.gloveTypes.map((col) => ({
          text: col.name,
          link: baseUrl + col.slug,
          count: `${col.skinGroups.count} skins`,
          image: col.image,
        })),
      },
    },
    {
      text: 'Colors',
      properties: {
        dropdown: true,
        options: data.colors.map((col) => ({
          text: col.name,
          link: baseUrl + col.slug,
          count: `${col?.itemColorLinks?.count} gloves`,
          hexColor: col.hexColor,
        })),
      },
    },
  ];

  buttons.push(
    ...filterPages
      .filter((v) => v.slug !== data.filterPage?.slug)
      .map((v) => ({
        text: typeof v.name === 'string' ? v.name : v.name('Gloves'),
        icon: v.icon,
        link: `/skins/gloves/${v.slug}`,
      }))
  );

  if (data.weapon || data.color || data.filterPage)
    buttons.push({
      text: 'All Gloves',
      link: '/skins/gloves',
      properties: { highlighted: true },
    });

  return buttons;
};

export default (data): ListConfigI => {
  const baseUrl = `/skins/gloves/${data.weapon.slug}`;
  const itemLink = (item) => `${baseUrl}/${item.slug}`;

  return _.merge(generate(data), {
    itemType: `${data.weapon.name}`,
    jumbo: {
      title: `All ${data.weapon.name} Skins`,
      text: `Below is a searchable list of all ${data.weapon.name} skins from Counter-Strike 2.`,
      imagePosition: 'top-left',
      image: strapiImage(data.items[0]?.image, 'thumbnail'),
      buttons: jumboButtons(data),
    },
    itemLink,
    meilisearch: {
      filters: [`skinGroup.weapon.id = ${data.weapon.id}`],
    },
  });
};
